import React from "react";
import { Stack } from "@mui/material";

const DSStack = (props: React.ComponentProps<typeof Stack>) => {
  return <Stack {...props} />;
};

export default DSStack;
